import { render } from "./SelectPagamento.vue?vue&type=template&id=a8ca4082&scoped=true"
import script from "./SelectPagamento.vue?vue&type=script&lang=js"
export * from "./SelectPagamento.vue?vue&type=script&lang=js"

import "./SelectPagamento.vue?vue&type=style&index=0&id=a8ca4082&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ca4082"]])

export default __exports__